<template>
  <div>
    <div class="container">
      <!-- 添加用语弹窗 -->
      <el-dialog title="添加用语"
                 :visible.sync="add_zhusu"
                 width="600px"
                 :close-on-click-modal="false">
        <div class="addbox">
          <div class="item mytext"
               v-for="(item, index) in list"
               :key="index">
            <el-input type="text"
                      placeholder="请输入内容"
                      v-model="list[index]"
                      class="additem"
                      maxlength="20"
                      show-word-limit
                      @input="
                (value) => {
                  return checkitem(value, index);
                }
              "
                      style="width: 502px"></el-input>
            <div class="btn"
                 v-if="index > 0">
              <el-button plain
                         icon="el-icon-delete"
                         circle
                         size="medium"
                         @click="delitem(index)"></el-button>
            </div>
          </div>
          <div style="text-align: left">
            <el-button plain
                       icon="el-icon-plus"
                       size="medium"
                       style="color: #669a60"
                       @click="additem">添加</el-button>
          </div>
        </div>
        <div style="height: 1px; background-color: #d9dadd; margin-bottom: 14px"></div>
        <div style="text-align: center; padding-bottom: 20px">
          <span slot="footer">
            <el-button plain
                       @click="add_zhusu = false"
                       style="width: 92px"
                       size="medium">取消</el-button>
            <el-button type="primary"
                       @click="submit"
                       style="width: 92px"
                       size="medium">保存</el-button>
          </span>
        </div>
      </el-dialog>
      <div>
        <div class="box">
          <div class="searchbox">
            <div>
              <el-input v-model="keyword"
                        placeholder="请输入内容"
                        style="width: 200px; margin-right: 10px"
                        @input="search"
                        clearable></el-input>
              <el-button type="info"
                         style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-right: 20px;
                "
                         @click="search">查询</el-button>
              <span>
                <el-radio v-model="sort_type"
                          :label="1"
                          @change="search">按首字母排序</el-radio>
                <el-radio v-model="sort_type"
                          :label="2"
                          @change="search">按修改时间排序</el-radio>
              </span>
            </div>
            <div>
              <el-button type="primary"
                         icon="el-icon-plus"
                         @click="
                  add_zhusu = true;
                  list = [''];
                  is_check = [];
                "
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('64') : false
                ">添加</el-button>
              <el-button type="primary"
                         @click="delAll"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('66') : false
                ">批量删除</el-button>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table ref="multipleTable"
                      :data="tableData"
                      tooltip-effect="dark"
                      style="width: 100%; min-width: 1000px"
                      :header-cell-style="{ background: '#F5F5F5' }"
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection"></el-table-column>

              <el-table-column label="主诉">
                <template slot-scope="scope">
                  <div v-if="scope.row.edit">
                    <el-input v-model="scope.row.symptom_name"
                              style="width: 300px; margin-right: 10px"
                              maxlength="20"></el-input>

                    <el-button plain
                               @click="
                        editSubmit(scope.row.symptom_id, scope.row.symptom_name)
                      "
                               style="color: #669961">确定</el-button>
                    <el-button plain
                               @click="getList"
                               style="color: #669961">取消</el-button>
                  </div>
                  <div v-else>{{ scope.row.symptom_name }}</div>
                </template>
              </el-table-column>

              <el-table-column label="修改时间"
                               prop="update_time"
                               width="220px"></el-table-column>

              <el-table-column label="操作"
                               width="220px">
                <template slot-scope="scope">
                  <el-button type="text"
                             @click="scope.row.edit = true"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('65')
                        : false
                    ">编辑</el-button>
                  <el-button type="text"
                             @click="delzhusu(scope.row.symptom_id, 0)"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('66')
                        : false
                    ">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="10"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="totalNum"
                           style="margin:20px 0"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import template from '../../../api/template';
import platform from '../../../api/platform';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      keyword: '',
      sort_type: 1,
      Selection: [],
      add_zhusu: false,
      list: [],
      is_check: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        keyword: this.keyword,
        sort_type: this.sort_type
      };
      template
        .getSymptomList(data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToTime(item.update_time);
              item.edit = false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleSelectionChange(val) {
      this.Selection = val;
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //删除
    delzhusu(symptom_id, status) {
      let text = '确定删除该内容？';
      if (status) {
        text = '确定批量删除勾选的内容？';
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          template.deleteSymptom({ symptom_id }).then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功!');
              this.getList();
            }
          });
        })
        .catch();
    },
    //批量删除
    delAll() {
      if (!this.Selection.length) {
        this.$message.error('请选择需要操作的内容');
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.symptom_id;
      });
      let symptom_id = selectId.toString();
      this.delzhusu(symptom_id, 1);
    },
    //添加用语
    additem() {
      if (this.list.length >= 20) {
        this.$message.error('一次添加最多支持20项');
        return false;
      }
      let aaa = '';
      this.list.push(aaa);
    },
    //删除添加列表里的用语
    delitem(index) {
      this.list.splice(index, 1);
      this.is_check.splice(index, 1);
    },
    //验证是否重复
    checkitem(value, index) {
      console.log(value);
      let symptom_name = value;
      template.checkSymptomName({ symptom_name }).then((res) => {
        if (res.code == 0) {
          if (res.data.is_exist) {
            this.$confirm(value + '内容重复！', '提示', {
              confirmButtonText: '确定'
            })
              .then(() => {})
              .catch();
            this.is_check[index] = 1;
          } else {
            this.is_check[index] = 0;
          }
        }
      });
    },
    //保存添加用语
    submit() {
      if (this.list.length == 1) {
      }
      let allIndex = this.findAll(this.is_check, 1);
      if (allIndex.length) {
        let row = allIndex.map((item) => {
          return item + 1;
        });
        let row_num = row.toString();
        this.$confirm('请修改第' + row_num + '行重复内容！', '提示', {
          confirmButtonText: '确定'
        })
          .then(() => {})
          .catch();
      } else {
        let symptom_id = 0;
        let symptom_name = JSON.stringify(_.uniq(this.list));
        template.saveSymptom({ symptom_id, symptom_name }).then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.add_zhusu = false;
            this.getList();
          }
        });
      }
    },
    findAll(a, x) {
      var results = [],
        len = a.length,
        pos = 0;
      while (pos < len) {
        pos = a.indexOf(x, pos);
        if (pos === -1) {
          //未找到就退出循环完成搜索
          break;
        }
        results.push(pos); //找到就存储索引
        pos += 1; //并从下个位置开始搜索
      }
      return results;
    },

    //编辑用语
    editSubmit(symptom_id, symptom_name) {
      template.checkSymptomName({ symptom_name }).then((res) => {
        if (res.code == 0) {
          if (res.data.is_exist) {
            this.$confirm(symptom_name + '内容重复！', '提示', {
              confirmButtonText: '确定'
            })
              .then(() => {})
              .catch();
            return false;
          } else {
            template.saveSymptom({ symptom_id, symptom_name }).then((res) => {
              if (res.code == 0) {
                this.$message.success('修改成功');
                this.getList();
              }
            });
          }
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.item {
  display: flex;
  margin-bottom: 10px;
  box-sizing: border-box;

  .additem {
    width: 700px;
    margin-right: 22px;
    box-sizing: border-box;
  }
  .btn {
    display: flex;
    align-items: center;
  }
}
.addbox {
  padding: 20px;
}
</style>
